import WebModule from '../web_module'

export default class Header extends WebModule

  @selector: '.modulor_web_module_header'

# do not register since this is just superclass
